import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  title = 'Tips and tricks';
  blogList: any[] = new Array();
  counter: number;

  private data = [
    {
      video: '/assets/images/blog_video1.png',
      title: 'Industry News',
      subTitle: 'Are you engaging with your sphere?',
      summary: 'While 75% of a Realtor’s business comes from referrals and word-of-mouth, agents still ' +
      'waste thousands of dollars and hours each year on cultivating new leads. Further, though 82% of Realtror’',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video2.png',
      title: 'Industry News',
      subTitle: 'What is your mind set about prospecting?',
      summary: 'What is your mind set about prospecting? Now I’m sure you’re probably not looking forward to it, ' +
      'none of us do. Now some of you hate it a little more than others. Because you haven’t quite dev',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video1.png',
      title: 'Industry News',
      subTitle: 'How are you attracting younger buyers?',
      summary: 'Say what you will about the younger generation, but they’re proving to be more financially ' +
      'savvy than previously anticipated. According to a report from realtor.org, “Gen Y comprises the larges',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video2.png',
      title: 'Industry News',
      subTitle: 'Realtors, Do you have "contactitis"?',
      summary: 'Some of you are really good prospectors, you do make a lot of contacts everyday and thats ' +
      'awesome and terrific. But you know Earl Nightingale said “We get what we think about most.”. So what are you',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video1.png',
      title: 'Industry News',
      subTitle: 'Realtors, ever use iBeacon for your open house?',
      summary: 'iBeacon technology makes this possible, by detecting your phone and sending you a ' +
      'message via an app that uses BLTE or Blue Tooth Low Energy technology. A boosted form of this ' +
      'system hits the phones of buyers',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video2.png',
      title: 'Industry News',
      subTitle: 'Realtors, Incentives used to close deals with home buyers',
      summary: 'While 75% of a Realtor’s business comes from referrals and word-of-mouth, agents still waste ' +
      'thousands of dollars and hours each year on cultivating new leads. Further, though 82% of Realtror’',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video1.png',
      title: 'Industry News',
      subTitle: 'Are you engaging with your sphere?',
      summary: 'While 75% of a Realtor’s business comes from referrals and word-of-mouth, agents still ' +
      'waste thousands of dollars and hours each year on cultivating new leads. Further, though 82% of Realtror’',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video2.png',
      title: 'Industry News',
      subTitle: 'What is your mind set about prospecting?',
      summary: 'What is your mind set about prospecting? Now I’m sure you’re probably not looking forward to it, ' +
      'none of us do. Now some of you hate it a little more than others. Because you haven’t quite dev',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video1.png',
      title: 'Industry News',
      subTitle: 'How are you attracting younger buyers?',
      summary: 'Say what you will about the younger generation, but they’re proving to be more financially ' +
      'savvy than previously anticipated. According to a report from realtor.org, “Gen Y comprises the larges',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video2.png',
      title: 'Industry News',
      subTitle: 'Realtors, Do you have "contactitis"?',
      summary: 'Some of you are really good prospectors, you do make a lot of contacts everyday and thats ' +
      'awesome and terrific. But you know Earl Nightingale said “We get what we think about most.”. So what are you',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video1.png',
      title: 'Industry News',
      subTitle: 'Realtors, ever use iBeacon for your open house?',
      summary: 'iBeacon technology makes this possible, by detecting your phone and sending you a ' +
      'message via an app that uses BLTE or Blue Tooth Low Energy technology. A boosted form of this ' +
      'system hits the phones of buyers',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    },{
      video: '/assets/images/blog_video2.png',
      title: 'Industry News',
      subTitle: 'Realtors, Incentives used to close deals with home buyers',
      summary: 'While 75% of a Realtor’s business comes from referrals and word-of-mouth, agents still waste ' +
      'thousands of dollars and hours each year on cultivating new leads. Further, though 82% of Realtror’',
      date: 'June 29,2016',
      blogBy: 'ReboReports'
    }
  ];

  constructor() {
    this.counter = 0;
    this.getData();
  }

  getData(){
    let index = this.counter += 12;
    this.blogList = this.data.slice(0, index >= this.data.length ? undefined : index);
    //index >= this.data.length
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/pages/blog/blog.component.ts